<template>
	<div class="block mijnschades">
		<div class="card">
			<div class="card-header"> <!-- add class solo if niet afgehandelde schades > 1 -->
				<h3>
					<a :href="ctx + '/mijnschades.html'">Mijn schades</a>
				</h3>
			</div>

			<div class="card-block full-width" v-if="mijnschades.length != 0">
				 <!-- show ul below if niet afgehandelde schades > 1 -->
				<ul class="link list insurances">
					<li v-for="schade in mijnschades" v-if="schade.schadestatus != 'afgehandeld'">
						<a :href="ctx + '/mijnschades.html'">
							<p class="icon icon-sm"><span :class="'icon-' + schade.produktTypeNaam"></span></p>
							<p>{{ schade.produktNaam }}</p>
							<span v-if="schade.kenteken">{{ schade.kenteken }}</span>
							<span v-if="schade.produktTypeNaam == 'woonhuis' || schade.produktTypeNaam == 'inboedel'">{{ schade.straat }}</span>
							<span class="tag" :class="[{'tag-danger':schade.schadestatus == 'wacht op uw reactie'}, {'tag-success':schade.schadestatus == 'in behandeling'}, {'tag-success':schade.schadestatus == 'beoordeling'}, {'tag-success':schade.schadestatus == 'ontvangen'}]">
								{{ schade.schadestatus }}
							</span>
						</a>
					</li>
				</ul>
				<div id="error"></div>
			</div>
		</div>
	</div>
</template>

<script>

    export default {
        name: 'mijnschades-component',
        props: {
            ctx: String
        },
        data: function () {
            return {
                mijnschades:[],
                pageDataLoaded: false
            }
        },
        mounted: function () {
            var self = this;
            $.ajax({
                url: this.ctx + "/services/mijnschades/getall",
                type: 'GET',
                success: function(mijnschades) {
                    self.mijnschades = mijnschades;
                    self.pageDataLoaded = true;
                },
                error: function() {
                    $('#error').html('<p>We hebben geen lopende schades gevonden.</p>');
                }
            });
        }
    }

</script>




// WEBPACK FOOTER //
// schadestatus.vue?39820826